
import {
  computed, defineComponent, onBeforeMount, reactive,
} from 'vue';
import { IRastreabilidadeVeiculo } from '@/models/Entidades/Estoques/IRastreabilidade';
import SelecionarMarcaModelo from '@/components/Cadastros/Veiculos/SelecionarMarcaModelo.vue';
import SelecionarCorVeiculo from '@/components/Cadastros/Veiculos/SelecionarCorVeiculo.vue';
import ServicoVeiculoCor from '@/servicos/Cadastros/Veiculo/ServicoVeiculoCor';
import ServicoVeiculoMarcaModelo from '@/servicos/Cadastros/Veiculo/ServicoVeiculoMarcaModelo';
import SelecionarTipoCombustivel from '@/components/Cadastros/Veiculos/SelecionarTipoCombustivel.vue';
import SelecionarTipoPintura from '@/components/Cadastros/Veiculos/SelecionarTipoPintura.vue';
import SelecionarCondicaoVIN from '@/components/Cadastros/Veiculos/SelecionarCondicaoVIN.vue';
import SelecionarTipoRestricao from '@/components/Cadastros/Veiculos/SelecionarTipoRestricao.vue';
import SelecionarCondicaoVeiculo from '@/components/Cadastros/Veiculos/SelecionarCondicaoVeiculo.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';

export default defineComponent({
  name: 'LancamentoRastreabilidadeVeiculo',
  props: {
    rastreabilidadeVeiculo: {
      type: Object as () => IRastreabilidadeVeiculo,
      required: true,
    },
    empresa: {
      type: Number,
      required: true,
    },
    qtdRastreabilidade: {
      type: Number,
      default: 0,
    },
    qtdCasasDecimais: {
      type: Number,
      default: 2,
    },
  },
  components: {
    SelecionarMarcaModelo,
    SelecionarCorVeiculo,
    SelecionarTipoCombustivel,
    SelecionarTipoPintura,
    SelecionarCondicaoVIN,
    SelecionarCondicaoVeiculo,
    SelecionarTipoRestricao,
    CampoNumerico,
  },
  emits: ['update:rastreabilidadeVeiculo', 'update:qtdrastreabilidade'],
  setup(props, { emit }) {
    const servicoVeiculoCor = new ServicoVeiculoCor();
    const servicoVeiculoMarcaModelo = new ServicoVeiculoMarcaModelo();

    const state = reactive({
      codigoModelo: 0,
      codigoCor: 0,
      tipoPintura: 1,
    });
    const computedRastreabilidadeVeiculo = computed({
      get: () => props.rastreabilidadeVeiculo,
      set: (valor: IRastreabilidadeVeiculo) => {
        emit('update:rastreabilidadeVeiculo', valor);
      },
    });

    const computedQtdRastreabilidade = computed({
      get: () => props.qtdRastreabilidade,
      set: (valor: number) => {
        emit('update:qtdrastreabilidade', valor);
      },
    });

    function obterTipoPintura() {
      computedRastreabilidadeVeiculo.value.tipoPintura = state.tipoPintura.toString();
    }

    function limparCampos() {
      state.codigoModelo = 0;
      state.codigoCor = 0;
      state.tipoPintura = 1;
      computedRastreabilidadeVeiculo.value.condicaoVeiculo = 1;
      computedRastreabilidadeVeiculo.value.condicaoVin = 1;
      computedRastreabilidadeVeiculo.value.tipoCombustivel = '06';
      computedRastreabilidadeVeiculo.value.distanciaEntreEixos = 0;
      computedRastreabilidadeVeiculo.value.tipoRestricao = 0;
      obterTipoPintura();
    }

    async function obterDadosModelo() {
      const modelo = await servicoVeiculoMarcaModelo.obter(state.codigoModelo, props.empresa);
      computedRastreabilidadeVeiculo.value.codigoMarcaModelo = modelo.codigoDenatran;
      computedRastreabilidadeVeiculo.value.anoFabricacao = modelo.anoFabricacao;
      computedRastreabilidadeVeiculo.value.anoModeloFabricacao = modelo.anoModelo;
      computedRastreabilidadeVeiculo.value.tipoVeiculo = modelo.tipoVeiculo;
      computedRastreabilidadeVeiculo.value.especieVeiculo = modelo.especieVeiculo;
      computedRastreabilidadeVeiculo.value.capacidadeMaximaLotacao = modelo.lotacaoMaxima;
    }

    async function obterDadosCor() {
      const cor = await servicoVeiculoCor.obter(state.codigoCor, props.empresa);
      computedRastreabilidadeVeiculo.value.codigoCor = cor.codigoInterno;
      computedRastreabilidadeVeiculo.value.codigoCorDenatran = cor.corDenatran.toString().padStart(2, '0');
      computedRastreabilidadeVeiculo.value.descricaoCor = cor.descricao;
    }

    onBeforeMount(async () => {
      limparCampos();
    });

    return {
      props,
      computedRastreabilidadeVeiculo,
      state,
      obterDadosModelo,
      obterDadosCor,
      obterTipoPintura,
      computedQtdRastreabilidade,
    };
  },
});
